<template>
  <div class="actions-wrapper q-gutter-sm">
    <q-btn
      v-for="(action, index) of actions"
      :key="`action_${index}`"
      :color="action.color"
      :flat="!!action.icon && !!!action.label"
      @click="onClick(action, params)"
    >
      <template v-if="action.label">{{ action.label }}</template>
      <template v-if="action.icon">
        <i :class="`fas fa-${action.icon} ${!!action.label ? 'on-right' : ''}`" />
      </template>
      <template v-if="action.tooltip">
        <LmTooltip>{{ action.tooltip }}</LmTooltip>
      </template>
    </q-btn>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '@router'
import store from '@store'

export default Vue.extend({
  name: 'LmGridEntityActions',
  router,
  store,

  computed: {
    actions() {
      const actions = this.params.context.actions
      return actions.filter(action => !this.isDisabled(action, this.params))
    }
  },

  methods: {
    onClick(action, params) {
      action.onClick(params)
    },
    isDisabled(action, params) {
      if (!action.hasOwnProperty('disable')) {
        return
      }
      return action.disable(params)
    }
  }
})
</script>
